import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: localStorage.getItem("access_token") ? 
        VueJwtDecode.decode(localStorage.getItem("access_token")
                            ).identity : '',
    totalInfo: {},
    shopinfo: {},
    aver: {},
    date: new Date().toISOString().substr(0, 7),
    domen: process.env.VUE_APP_BACK_DOMEN || '',
    version: '',
    not_found: "https://251317.selcdn.ru/oboi.ru/no_results_found.png",
    coin: "https://251317.selcdn.ru/oboi.ru/sup/coinbig.gif",
    logoWhite: 'https://251317.selcdn.ru/oboi.ru/logo/%D0%BB%D0%BE%D0%B3%D0%BE%20%D0%B1%D0%B5%D0%BB%D1%8B%D0%B9.png',
    logo: 'https://251317.selcdn.ru/oboi.ru/logo/%D0%BB%D0%BE%D0%B3%D0%BE%20%D0%BE%D1%81%D0%BD%D0%BE%D0%B2%D0%BD%D0%BE%D0%B9.png',
  },

  mutations: {

    'set_username'(state, value) {
      state.username = value;
    },
    'set_total_info'(state, value) {
      state.totalInfo = value;
    },
    'set_shop_info'(state, value) {
      state.shopinfo = value;
    },
    'set_date'(state, value) {
      state.date = value;
    },
    'set_aver'(state, value){
      state.aver = value;
    },
    'set_version'(state, value){
      state.version = value;
    },
    'set_domen'(state, value){
      state.domen = value;
    }
  },

  actions: {

    init_total_info: ({commit, state}) => {
      axios.post(state.domen + '/service/bossboard', {
            'year': new Date(state.date).getFullYear(),
            'month': new Date(state.date).getMonth() + 1
      }).then(res => res.data)
        .then(json => {
          commit('set_total_info', json['response']);
          let info = {};
          for (let el of json['response'].shopinfo) info[el.ID] = el;
          commit('set_shop_info', info);
      })
    },

    init_aver: ({commit, state}) => {
      axios.post(state.domen + '/service/average', {
          'month': 3
      }).then(res => res.data)
        .then(json => commit('set_aver', json['response']));
    },

    init_settings: ({commit}) => {
      fetch(`/config.json?v=${Math.random()}`, {method: 'GET'})
        .then(res => res.json())
        .then(json => {
          // console.log(json);
          if (json['Version']) commit('set_version', json['Version']);
          if (json['Baseurl']) commit('set_domen', json['Baseurl']);
          // console.log(state.version, state.back_domen)
      }).catch(() => window.console.log('err config.json'));
    }

  },
  modules: {
  }
})
